import useConfigurationGlobals from '@/composables/useConfigurationGlobals';

export default () => {
  const { $BRAND } = useConfigurationGlobals();

  const secureOrigin = `https://secure.${$BRAND.toLowerCase()}.com`;

  const secureUrl = (path = '') => `${secureOrigin}${path}`;

  const signinUrl = ({ app = 'www', rd }) => {
    const params = new URLSearchParams({ app });
    if (rd) params.set('rd', rd);
    return `${secureOrigin}/?${params}`;
  };

  const signoutUrl = ({ app = 'wx', rd = 'Search.aspx' }) => {
    return `${secureOrigin}/?signout=true&app=${app}&rd=${rd}`;
  };

  return {
    secureOrigin,
    secureUrl,
    signinUrl,
    signoutUrl,
    upgradeUrl: secureUrl('/features'),
    accountUrl: secureUrl('/account'),
    signupUrl: secureUrl('/signup'),
  };
};
